"use client";

import React, { lazy } from "react";
import { Image, isNextBuild } from "@/lib/target";
import Clock_fill from "@/public/Clock_fill.svg";
import Clock_fill_white from "@/public/Clock_fill_white.svg"
import { BANKER } from "../../../contants";
import { Tooltip } from "@nextui-org/react";
import { useSelector } from "@/lib/redux/store";

const PopupButtonDesktop = lazy(() => import('@/components/client/PopupButtonDesktop'));

const BangkeoHeader = ({ onBookMakerChange, hideCompanies }) => {
  const toggleReducer = useSelector((state) => state.toggleReducer);  
  return (
    <div className="hidden @lg:flex items-center justify-between bg-header-odds-blue dark:bg-dark-slate font-[600] rounded-[2px] py-[7px] px-[13px] gap-3">
      <div className="flex ml-[20px] gap-[50px] w-[12rem]">
        <div className="flex items-center text-dark-gray dark:text-stroke-o3 text-xs font-medium gap-1">
          <Image alt="Net88" src={Clock_fill} width={20} height={20} className="block dark:hidden" />
          <Image alt="Net88" src={Clock_fill_white} width={20} height={20} className=" hidden dark:block" />
          <p>Giờ</p>
        </div>
        <div className="text-dark-gray dark:text-stroke-o3 text-xs font-xs">Giải</div>
      </div>
      <div className="flex flex-1 gap-[25px] ">
        <div className="flex-1 text-button-blue-bet dark:text-stroke-o3 text-xs font-semi-bold text-right">
          Nhà
        </div>
        <div className="text-button-blue-bet dark:text-stroke-o3 text-xs font-semi-bold w-[80px] text-center">
          Tỷ Số
        </div>
        <div className="flex-1 text-button-blue-bet dark:text-stroke-o3 text-xs font-semi-bold">
          Khách
        </div>
      </div>
      <div className={`flex items-center ${isNextBuild ? 'gap-[40px]' : 'gap-[15px]'}`}>
        <div className="flex">
          <div className={`flex-1 w-[40px] text-dark-gray dark:text-stroke-o3 text-xs font-xs ${hideCompanies && 'pl-[6px]'} ${!isNextBuild && 'text-center'}` }>
          {(toggleReducer?.corner && (
            <Tooltip
              showArrow={true}
              content="Góc"
              className="bg-sm-dark-gray rounded px-2"
            >
              C/H-T
            </Tooltip>
          ))}
          </div>
          <div className={`flex-1 w-[80px] text-dark-gray dark:text-stroke-o3 text-xs font-xs ${hideCompanies && 'text-center pl-[10px]'} ${!isNextBuild && 'text-center'}`}>
            Số liệu
          </div>
        </div>
        {!hideCompanies && (
        <div className={`${isNextBuild ? 'w-[100px]' : 'w-[145px]'} text-center`}>
          {isNextBuild ? (
            <PopupButtonDesktop
              data={BANKER}
              handleChange={onBookMakerChange}
              type={"bookmarker"}
            />
          ) : ('Tỷ lệ')}
        </div>
        )}
      </div>
    </div>
  );
};

export default BangkeoHeader;
